import { QueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

import { shouldSuppressErrorNotification } from "@/utils/sessionExpiryError";

export const useQueryClient = (
  handleError: (err: unknown, errorMessage?: string) => void,
) => {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            onError: (err) => {
              if (!shouldSuppressErrorNotification(err)) {
                handleError(err);
              }
            },
            retry: false,
          },
          mutations: {
            onError: (err) => {
              if (!shouldSuppressErrorNotification(err)) {
                handleError(err);
              }
            },
          },
        },
      }),
    [handleError],
  );

  return queryClient;
};
